<template>
  <div class="eject_select_list" v-show="isShow">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.isShow = this.show
    })
  },
  methods: {
    switchHandleDocument() {
      if (this.isShow) {
        setTimeout(() => {
          document.addEventListener('click', this.handleDocumentClick, false);
        }, 0);
      } else {
        document.removeEventListener('click', this.handleDocumentClick, false);
      }
    },
    handleDocumentClick() {
      this.isShow = false
      this.$emit('update:show', false)
      document.removeEventListener('click', this.handleDocumentClick, false);
    },
  },
  watch: {
    show(newV) {
      this.isShow = newV
      this.switchHandleDocument()
    },
  },
  destroyed() {
    document.removeEventListener('click', this.handleDocumentClick, false);
  },
};
</script>

<style lang='less' scoped>
.eject_select_list {
  position: absolute;
  z-index: 10;
  top: 50px;
  left: 50%;
  overflow: auto;
  width: 160px;
  min-height: 100px;
  max-height: 350px;
  transform: translateX(-50%);
  border-radius: 10px;
  background: #FFFFFF;
  box-shadow: 0 0 10px #CCCCCC;

  p {
    overflow: hidden;
    height: 50px;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 50px;

    &:hover {
      background: rgba(240, 240, 240, .5);
    }
  }

  .on {
    background: #F4F7FF;
  }
}


</style>